import { render, staticRenderFns } from "./DialogApuracaoContratoCancelamento.vue?vue&type=template&id=871b311e"
import script from "./DialogApuracaoContratoCancelamento.vue?vue&type=script&lang=js"
export * from "./DialogApuracaoContratoCancelamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports